import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { name: String };

  connect() {
    if (!this.nameValue) return;
    document.dispatchEvent(new CustomEvent(this.nameValue));
  }
}
